var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5333 12.4038V14.4475H10.8701V9.40264H12.6289C13.0532 9.39459 13.461 9.55149 13.7699 9.84114C14.0788 10.1107 14.2518 10.5009 14.2436 10.9032C14.2518 11.3095 14.0788 11.6998 13.7699 11.9733C13.461 12.259 13.082 12.4038 12.633 12.4038H11.5333ZM11.5333 10.0222V11.7842H12.6454C12.8925 11.7923 13.1314 11.6957 13.3003 11.5228C13.6504 11.1929 13.6546 10.6498 13.3168 10.3078L13.3003 10.2917C13.1314 10.1147 12.8925 10.0182 12.6454 10.0262L11.5333 10.0222ZM15.7717 10.8831C16.2619 10.8831 16.6491 11.0118 16.9333 11.2653C17.2175 11.5228 17.3575 11.8728 17.3575 12.3193V14.4434H16.7232V13.9647H16.6944C16.4184 14.359 16.0559 14.5561 15.5987 14.5561C15.2115 14.5561 14.882 14.4434 14.6225 14.2182C14.3671 14.009 14.223 13.6992 14.2312 13.3733C14.2312 13.0153 14.3713 12.7337 14.6472 12.5205C14.9232 12.3072 15.2939 12.2026 15.7552 12.2026C16.1507 12.2026 16.4719 12.2751 16.7273 12.4118V12.263C16.7273 12.0417 16.6285 11.8325 16.4555 11.6917C16.2784 11.5388 16.0518 11.4544 15.817 11.4544C15.4463 11.4544 15.1539 11.6072 14.9356 11.913L14.3507 11.5549C14.6678 11.1084 15.1415 10.8831 15.7717 10.8831ZM14.915 13.3894C14.915 13.5584 14.9973 13.7153 15.1333 13.8118C15.2816 13.9245 15.4628 13.9848 15.6481 13.9808C15.9282 13.9808 16.196 13.8722 16.3937 13.6791C16.612 13.4779 16.7232 13.2406 16.7232 12.967C16.5173 12.8061 16.2289 12.7256 15.8582 12.7256C15.5905 12.7256 15.3639 12.79 15.1827 12.9147C15.0056 13.0434 14.915 13.2003 14.915 13.3894ZM20.9987 10.9957L18.7827 15.9682H18.099L18.9227 14.2302L17.4646 10.9998H18.1855L19.2358 13.4779H19.2523L20.2779 10.9998L20.9987 10.9957Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85306 11.9604C8.85306 11.7633 8.83658 11.5662 8.80363 11.373H6.00684V12.4874H7.60912C7.54322 12.8455 7.32903 13.1673 7.01599 13.3684V14.0926H7.9716C8.53178 13.5897 8.85306 12.8455 8.85306 11.9604Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00447 14.7926C6.80355 14.7926 7.47907 14.5351 7.96923 14.0926L7.01362 13.3684C6.74589 13.5454 6.40401 13.646 6.00447 13.646C5.2301 13.646 4.57518 13.1351 4.3404 12.4512H3.35596V13.1994C3.85847 14.173 4.8841 14.7926 6.00447 14.7926Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34169 12.4523C4.21812 12.0942 4.21812 11.704 4.34169 11.3419V10.5977H3.35725C3.14807 11.0003 3.03906 11.4455 3.03906 11.8971C3.03906 12.3486 3.14807 12.7938 3.35725 13.1965L4.34169 12.4523Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00447 10.1462C6.42872 10.1382 6.8365 10.2951 7.14131 10.5807L7.9857 9.75601C7.45023 9.26118 6.74177 8.99164 6.00447 8.99969C4.8841 8.99969 3.85847 9.61923 3.35596 10.5968L4.3404 11.3451C4.57518 10.6572 5.2301 10.1462 6.00447 10.1462Z",
    fill: "#EA4335"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 4.2,
    width: 23.6,
    height: 15.6,
    rx: 7.8,
    stroke: "#1D1D1D",
    strokeWidth: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 7,
    fill: "white",
    transform: "translate(3 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.0e5669ca3cf8e5e00a5f203fbb6a9674.svg";
export { ForwardRef as ReactComponent };